import {IChecklist} from "../../varibles/interface";
import {createSliceSelectors} from "../selectors";

export const NAME_SLICE = 'checklist'

export interface ChecklistState {
    data: IChecklist[]

    steps: {
        data: { [id: string]: string[] },
        loading: boolean
    }

    loading: boolean
}

export const initialState: ChecklistState = {
    data: [],

    steps: {
        data: {},
        loading: false
    },

    loading: false,
}

export const selectChecklist = createSliceSelectors(NAME_SLICE, initialState);
